<script lang="ts" setup>
import Message from 'primevue/message';
import Textarea from 'primevue/textarea';
import { AppFloatingLabelWrapper } from '~/components/base';
import type { FloatLabelVariant } from '~/types/components/base/FloatLabel';
import type {
  TextareaSize,
  TextareaVariant,
} from '~/types/components/base/Textarea';
import { IN } from '~/utils/enums/components/base/FloatLabel';

defineOptions({
  inheritAttrs: false,
});

/**
 * https://primevue.org/textarea/#api.textarea.props
 */
const {
  placeholder = undefined,
  label = undefined,
  variant = undefined,
  size = undefined,
  errorMessage = undefined,

  floatingLabel = true,
  floatingLabelVariant = IN,
  disabled = false,
  loading = false,
  invalid = false,
  autoResize = false,
} = defineProps<{
  placeholder?: string;
  label?: string;
  variant?: TextareaVariant;
  size?: TextareaSize;
  errorMessage?: string;

  floatingLabel?: boolean;
  floatingLabelVariant?: FloatLabelVariant;
  disabled?: boolean;
  loading?: boolean;
  invalid?: boolean;
  autoResize?: boolean;
}>();
</script>

<template>
  <AppFloatingLabelWrapper
    :floating-label="floatingLabel"
    :floating-label-variant="floatingLabelVariant"
    :label="label"
  >
    <template #default="{ labelId: id }">
      <Textarea
        :id="id"
        :variant="variant"
        :size="size"
        :disabled="disabled"
        :loading="loading"
        :invalid="invalid"
        :auto-resize="autoResize"
        :label="floatingLabel ? undefined : label"
        :placeholder="floatingLabel ? undefined : placeholder"
        class="app-textarea"
        v-bind="$attrs"
      />
    </template>
  </AppFloatingLabelWrapper>

  <Message
    v-if="!!errorMessage"
    severity="error"
    size="small"
    variant="simple"
    class="mt-2"
    >{{ errorMessage }}</Message
  >
</template>

<style lang="scss" scoped>
.app-textarea {
}
</style>
